import coinflip from '../../../../coinflip';
import checkFiberWithinComponent from './check-fiber-within-component';
import findFiberWithCache from './find-fiber-with-cache';
const DEFAULT_MAX_LEVEL = 20;

// Cache cleanup
let callCount = 0;
const CLEANUP_THRESHOLD = 50;
function maybeCleanup(resultCache) {
  callCount++;
  if (callCount >= CLEANUP_THRESHOLD && coinflip(0.3)) {
    cleanupCaches(resultCache);
  }
}
export function cleanupCaches(resultCache) {
  resultCache = new WeakMap();
  callCount = 0;
  return resultCache;
}
export default function checkWithinComponent(node, targetComponentName, resultCache) {
  maybeCleanup(resultCache);
  if (resultCache.has(node)) {
    var _resultCache$get;
    return {
      isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
    };
  }
  let fiber = null;
  let checkedNodes = [];

  // Always use cached fiber strategy to handle non-React elements reliably
  fiber = findFiberWithCache(node, DEFAULT_MAX_LEVEL, checkedNodes);
  if (!fiber) {
    checkedNodes.forEach(checkedNode => {
      resultCache.set(checkedNode, false);
    });
    return {
      isWithin: false
    };
  }
  const isWithin = checkFiberWithinComponent(fiber, targetComponentName, DEFAULT_MAX_LEVEL);
  checkedNodes.forEach(checkedNode => {
    resultCache.set(checkedNode, isWithin);
  });
  return {
    isWithin
  };
}